import React, { useEffect, useState } from 'react';
import { BellIcon, XIcon } from 'lucide-react';
const NAMES = [{
  name: 'Florencia B.',
  location: 'La Plata'
}, {
  name: 'Lucía M.',
  location: 'Rosario'
}, {
  name: 'Carolina G.',
  location: 'Buenos Aires'
}, {
  name: 'Valentina R.',
  location: 'Córdoba'
}, {
  name: 'Marcela P.',
  location: 'Rosario'
}, {
  name: 'Sofía L.',
  location: 'Mendoza'
}, {
  name: 'Andrea C.',
  location: 'Mar del Plata'
}, {
  name: 'María J.',
  location: 'Tucumán'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    location: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomPerson = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 2; // 2 to 16 minutes
      setCurrentPurchase({
        name: randomPerson.name,
        location: randomPerson.location,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show every 35 seconds
    const interval = setInterval(showPopup, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-50 animate-slide-in-left font-['Lato',sans-serif]" data-id="element-402">
      <div className="bg-white rounded-r-lg shadow-[0_4px_20px_rgba(0,0,0,0.15)] border-l-4 border-l-[#27AE60] p-4 max-w-[320px] flex items-start gap-3 relative" data-id="element-403">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-404">
          <XIcon className="w-4 h-4" data-id="element-405" />
        </button>

        <div className="mt-1" data-id="element-406">
          <BellIcon className="w-5 h-5 text-[#27AE60]" fill="#27AE60" fillOpacity={0.2} data-id="element-407" />
        </div>

        <div className="flex-1 pr-4" data-id="element-408">
          <p className="text-xs font-bold text-[#27AE60] uppercase tracking-wide mb-1" data-id="element-409">
            Compra verificada
          </p>
          <p className="text-sm text-[#444444] leading-snug" data-id="element-410">
            <strong data-id="element-411">{currentPurchase.name}</strong> de{' '}
            {currentPurchase.location} compró Método RESET 24 H. 💑
          </p>
          <p className="text-xs text-gray-500 mt-1.5" data-id="element-412">
            hace {currentPurchase.time} minutos
          </p>
        </div>
      </div>
    </div>;
}